import { render } from "./TermsOfService.vue?vue&type=template&id=81fe4bb6&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=81fe4bb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fe4bb6"]])

export default __exports__